import React from 'react';
import styles from '../../styles/PokemonItem.module.css';
import icon from '../../styles/PokemonIcon.module.css';

const PokemonItem = ({ pokemon, onClick, isSelected }) => {
    return (
        <li 
            className={`${styles.pokemonItem} ${isSelected ? styles.selected : ''}`}
            onClick={() => onClick(pokemon)}
            
        >
            <img className={`${icon.icon} ${styles.icon}`} src={pokemon.icon} alt={pokemon.nom} />
            {/* <p>{pokemon.nom}</p> */}
        </li>

    );
};

export default PokemonItem;